import { ValidationError } from 'components/forms/validators/validation-error';

/** Validates optional QR IDs using the backend's Unicode code-point contract. */
export default function deviceQrId(value?: string): ValidationError | null {
  if (!value) {
    return null;
  }

  if (value.includes('\0')) {
    return { message: 'QR ID nesmie obsahovať nulový znak' };
  }

  if (Array.from(value).length > 255) {
    return { message: 'QR ID môže obsahovať najviac 255 znakov' };
  }

  return null;
}
